var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rounded-md bg-blue-50 p-4" }, [
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "flex-shrink-0" }, [
        _c(
          "svg",
          {
            staticClass: "h-5 w-5 text-blue-400",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 20 20",
              fill: "currentColor",
              "aria-hidden": "true",
            },
          },
          [
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                "clip-rule": "evenodd",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "ml-3 flex-1 md:flex md:justify-between text-sm text-blue-700",
        },
        [_vm._t("default")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }